<div class="filters-card">
  <div class="filters-header">
    <div class="filters-heading">
      <div class="filters-title">
        <mat-icon class="filters-title-icon">tune</mat-icon>
        <span>Filtros</span>
        <span class="filters-count" *ngIf="activeFilterChips.length">{{
          activeFilterChips.length
        }}</span>
      </div>
      <p class="filters-subtitle">
        Busca por file, OS o proveedor y refina el listado sin volver a consultar
        Core.
      </p>
    </div>

    <button
      *ngIf="hasActiveFilters"
      type="button"
      mat-stroked-button
      class="btn-clear-all"
      [disabled]="disabled"
      (click)="clearAll.emit()"
    >
      <mat-icon>filter_alt_off</mat-icon>
      Limpiar filtros
    </button>
  </div>

  <div class="filters-row">
    <div class="search-filter-cell">
      <mat-form-field appearance="outline" class="filter-field filter-search">
        <mat-label>Buscar file, OS o proveedor</mat-label>
        <mat-icon matPrefix class="field-prefix-icon">search</mat-icon>
        <input
          matInput
          type="search"
          autocomplete="off"
          placeholder="Ej. 202501234 o proveedor"
          [ngModel]="filters.searchValue"
          [disabled]="disabled"
          (ngModelChange)="onSearchChange($event)"
        />
        <button
          *ngIf="filters.searchValue"
          mat-icon-button
          matSuffix
          type="button"
          class="search-clear-suffix"
          aria-label="Limpiar búsqueda"
          [disabled]="disabled"
          (click)="onSearchChange('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <span class="search-helper-message">
        Filtra en memoria sobre las OS ya cargadas
      </span>
    </div>

    <mat-form-field appearance="outline" class="filter-field filter-select">
      <mat-label>Año</mat-label>
      <mat-icon matPrefix class="field-prefix-icon">event</mat-icon>
      <mat-select
        [value]="filters.yearFile"
        [disabled]="disabled"
        (selectionChange)="onYearChange($event.value)"
      >
        <mat-option [value]="null">Todos los años</mat-option>
        <mat-option
          *ngFor="let year of filterOptions.years; trackBy: trackByYear"
          [value]="year"
          >{{ year }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field filter-select">
      <mat-label>Estado OS</mat-label>
      <mat-icon matPrefix class="field-prefix-icon">flag</mat-icon>
      <mat-select
        [value]="filters.orderStatus"
        [disabled]="disabled"
        (selectionChange)="onStatusChange($event.value)"
      >
        <mat-option [value]="null">Todos los estados</mat-option>
        <mat-option
          *ngFor="let status of filterOptions.orderStatuses; trackBy: trackByStatus"
          [value]="status"
          >{{ status }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field filter-select filter-provider">
      <mat-label>Proveedor</mat-label>
      <mat-icon matPrefix class="field-prefix-icon">storefront</mat-icon>
      <mat-select
        [value]="filters.providerName"
        [disabled]="disabled"
        (selectionChange)="onProviderChange($event.value)"
      >
        <mat-option [value]="null">Todos los proveedores</mat-option>
        <mat-option
          *ngFor="let provider of filterOptions.providers; trackBy: trackByProvider"
          [value]="provider"
          >{{ provider }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field filter-date">
      <mat-label>Fecha de pago</mat-label>
      <mat-icon matPrefix class="field-prefix-icon">date_range</mat-icon>
      <mat-date-range-input
        [rangePicker]="paidAtRangePicker"
        [disabled]="disabled"
      >
        <input
          matStartDate
          placeholder="Desde"
          [ngModel]="filters.paidAtFrom"
          (ngModelChange)="onPaidAtFromChange($event)"
        />
        <input
          matEndDate
          placeholder="Hasta"
          [ngModel]="filters.paidAtTo"
          (ngModelChange)="onPaidAtToChange($event)"
        />
      </mat-date-range-input>
      <button
        *ngIf="filters.paidAtFrom || filters.paidAtTo"
        mat-icon-button
        matSuffix
        type="button"
        class="date-clear-suffix"
        aria-label="Limpiar fecha de pago"
        [disabled]="disabled"
        (click)="clearPaidAtRange()"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-datepicker-toggle
        matSuffix
        [for]="paidAtRangePicker"
      ></mat-datepicker-toggle>
      <mat-date-range-picker #paidAtRangePicker></mat-date-range-picker>
    </mat-form-field>
  </div>

  <div class="filters-footer">
    <div class="active-filters-row" [class.empty]="!activeFilterChips.length">
      <ng-container *ngIf="activeFilterChips.length; else noActiveFilters">
        <span class="active-filters-label">Activos:</span>
        <div class="active-filters-chips">
          <span
            class="filter-chip"
            *ngFor="let chip of activeFilterChips; trackBy: trackByChip"
          >
            <span class="filter-chip-text">{{ chip.label }}</span>
            <button
              type="button"
              class="filter-chip-remove"
              [disabled]="disabled"
              (click)="removeFilter.emit(chip.id)"
              [attr.aria-label]="'Quitar filtro ' + chip.label"
            >
              <mat-icon>close</mat-icon>
            </button>
          </span>
        </div>
      </ng-container>
      <ng-template #noActiveFilters>
        <span class="active-filters-placeholder">Sin filtros activos</span>
      </ng-template>
    </div>
  </div>
</div>
